/**
 * __mocks__/apiResponses/v3/chats.js
 * Autogenerated via generateMockRoute.js
 * DO NOT MODIFY THIS FILE STRUCTURE DIRECTLY.
 */

/** @type {import('../../mockRequestHandler').EndpointMockConfig} */
export default {
  "/v3/chats": {
    active: true,
    GET: {
      active: true,
      default: {
        responseValues: {
          status: 200,
          response: [
            {
              id: "1",
              name: "Jamie Lopez",
              childFullName: "Kai Lopez",
              imageUrl: null,
              lastMessage:
                "Hey! Just wanted to let you know that I need the documents Hey! Just wanted to let you know that I need the documents Hey! Just wanted to let you know that I need the documents Hey! Just wanted to let you know that I need the documents",
              timestamp: "2025-05-06T10:15:00.000Z",
              unread: true,
            },
            {
              id: "2",
              name: "John Doe",
              childFullName: "Sophia Doe",
              imageUrl: null,
              lastMessage: "Yep! Got it. Thx",
              timestamp: "2025-05-06T08:30:00.000Z",
              unread: true,
            },
            {
              id: "3",
              name: "Katherine Hughes",
              childFullName: "Leo Hughes",
              imageUrl:
                "https://an-user-profile-images-staging.s3.amazonaws.com/1565824628979-1DAC48CB-C125-4F2A-BE2D-985101C1B299.jpeg",
              lastMessage: "We’ve added Dad as a team member. He",
              timestamp: "2025-05-04T15:10:00.000Z",
              unread: false,
            },
            {
              id: "4",
              name: "Justin Wright",
              childFullName: "Maya Wright",
              imageUrl: null,
              lastMessage: "Can we push Kai’s next appointment to our Monday",
              timestamp: "2025-05-03T11:45:00.000Z",
              unread: false,
            },
            {
              id: "5",
              name: "Emily Carter",
              childFullName: "Jackson Carter",
              imageUrl: null,
              lastMessage: "Looking forward to our session tomorrow!",
              timestamp: "2025-05-05T17:00:00.000Z",
              unread: true,
            },
            {
              id: "6",
              name: "Brian Lee",
              childFullName: "Ella Lee",
              imageUrl: null,
              lastMessage: "We had a great breakthrough today.",
              timestamp: "2025-05-02T09:20:00.000Z",
              unread: false,
            },
            {
              id: "7",
              name: "Monica Tran",
              childFullName: "Lucas Tran",
              imageUrl: null,
              lastMessage: "Please send over the updated forms.",
              timestamp: "2025-05-06T12:05:00.000Z",
              unread: true,
            },
            {
              id: "8",
              name: "Carlos Ramirez",
              childFullName: "Isabella Ramirez",
              imageUrl: null,
              lastMessage: "Let’s reschedule to next week if possible.",
              timestamp: "2025-05-04T13:15:00.000Z",
              unread: false,
            },
          ],
        },
      },
      scenarios: {
        user_145593: {
          active: false,
          condition: {
            params: {
              userId: "145593",
            },
          },
          responseValues: {
            status: 200,
            response: [
              {
                id: "1",
                name: "Jamie Lopez",
                lastMessage: "Hey! Just wanted to let you know that I need the documents",
                timestamp: "2025-05-02T08:08:00.000Z",
                unread: true,
              },
              {
                id: "2",
                name: "John Doe",
                lastMessage: "Yep! Got it. Thx",
                timestamp: "2025-05-01T18:30:00.000Z",
                unread: true,
              },
            ],
          },
        },
      },
    },
    POST: {
      active: false,
      default: {
        responseValues: {
          response: null,
          status: 204,
        },
      },
      scenarios: {},
    },
    PUT: {
      active: false,
      default: {
        responseValues: {
          response: null,
          status: 204,
        },
      },
      scenarios: {},
    },
    DELETE: {
      active: false,
      default: {
        responseValues: {
          response: null,
          status: 204,
        },
      },
      scenarios: {},
    },
  },
};
